import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk';
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant';

import { errorHandlingMiddleware } from '@gts-common/client';
import { serverComm } from '@gts-ns/ui';
import { initialState } from './initialState';
import { rootReducer } from './reducers/rootReducer';
import { ReduxState } from './types';
import { Actions } from './actions/reduxActionTypes';

type WindowWithDevTools = typeof window & {
  __REDUX_DEVTOOLS_EXTENSION__: typeof compose;
};

const enableDevTool =
  process.env.NODE_ENV !== 'production' &&
  (window as WindowWithDevTools).__REDUX_DEVTOOLS_EXTENSION__;

const commonMiddleware = [
  errorHandlingMiddleware(serverComm),
  thunkMiddleware as ThunkMiddleware<ReduxState, Actions>,
];

const middleware =
  process.env.NODE_ENV !== 'production'
    ? [...commonMiddleware, immutableStateInvariantMiddleware()]
    : commonMiddleware;

export const store = createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    enableDevTool
      ? (window as WindowWithDevTools).__REDUX_DEVTOOLS_EXTENSION__()
      : (f: unknown) => f,
  ),
);
